import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Col } from 'react-bootstrap'

import { CONFIG } from 'Config/config'
import { DATE_NAME_FORMAT } from 'constants.js'
import { dateFormatter } from 'Utils/Formatters'
import { getMetricResultsFromConversionsMap } from '../../../../Utils/Mission'
import { ModalLightbox } from '../../../../Components/Modal/ModalLightbox'
import { LinkExternal } from '../../../../Components/LinkExternal'
import { MissionMap } from '../../../../Components/Missions/MissionMap'
import {
  Section,
  SectionLabel,
  SectionRow,
} from '../../../../Components/Section'
import {
  dropTimeZoneFromDate,
  simplerGetTimeOfDayFromDate,
} from '../../../../shared/libraries/utils/date'
import { authorization } from '../../../../Module/Auth/Auth'
import { formatFieldValue } from '../../../../Utils/Formatters'
import { MISSION_ENUM_TYPES } from '../../../../shared/constants'
import { getDistance } from '../../../../shared/libraries/geo'
import format from 'date-fns/format'

const getStepsFromActivity = activities => {
  const stepLength = 0.72
  const meters = activities.reduce((acc, activity, index, activities) => {
    if (activities[index + 1]) {
      acc += getDistance(
        activity.latitude,
        activity.longitude,
        activities[index + 1].latitude,
        activities[index + 1].longitude,
      )
    }
    return acc
  }, 0)
  return Math.floor(meters / stepLength)
}
const MissionDetails = ({ mission }) => {
  const metrics = useMemo(
    () =>
      Array.from(getMetricResultsFromConversionsMap(mission.conversions)).map(
        ([metricId, { name, value }]) => ({ name, value }),
      ),
    [mission.conversions],
  )

  const timeStart = useMemo(
    () => dropTimeZoneFromDate(mission.timeRangeStart),
    [mission.timeRangeStart],
  )

  const timeOfDay = useMemo(
    () =>
      mission.cityPlan.city
        ? simplerGetTimeOfDayFromDate(timeStart, mission.cityPlan.city)
        : '',
    [timeStart, mission.cityPlan.city],
  )

  const shouldShowCurrentPosition =
    authorization.isSpy() ||
    authorization.isCityManager() ||
    authorization.isAdmin()

  return (
    <Section title={'Mission Details'}>
      <SectionRow>
        <Col xs={3}>
          <SectionLabel>Client</SectionLabel>
          {mission.client.name}
        </Col>
        <Col xs={3}>
          <SectionLabel>Date</SectionLabel>
          {dateFormatter(timeStart, DATE_NAME_FORMAT)}
        </Col>
        <Col xs={3}>
          <SectionLabel>Time</SectionLabel>
          {format(new Date(timeStart), 'hh:mma')} {timeOfDay}
        </Col>
        <Col xs={3}>
          <SectionLabel>Flyers Qty</SectionLabel>
          {`${
            mission.totalFlyersDistributed ? mission.totalFlyersDistributed : 0
          } 
        / ${mission.flyerCodeV2 ? mission.flyerCodeV2.quantity : ''}`}
        </Col>
      </SectionRow>

      <SectionRow>
        <Col xs={3}>
          <SectionLabel>Flyer pack</SectionLabel>
          {mission.checkInFlyerPackImage ? (
            <ModalLightbox
              linkText="View flyer pack photo"
              image={mission.checkInFlyerPackImage}
            />
          ) : (
            '-'
          )}
        </Col>
        <Col xs={3}>
          <SectionLabel>Flyer Code</SectionLabel>
          {mission.flyerCodeV2 ? mission.flyerCodeV2.code : '-'}

          {mission.checkInFlyerCodeImage ? (
            <ModalLightbox
              linkText="View flyer code photo"
              image={mission.checkInFlyerCodeImage}
            />
          ) : (
            ''
          )}
        </Col>
        {mission.location && (
          <Col xs={3}>
            <SectionLabel>Location</SectionLabel>
            {mission.location.name}
            <LinkExternal
              href={CONFIG.GOOGLE_PLACE_URL(mission.location)}
              target="_blank"
              className="view-map"
            >
              view map
            </LinkExternal>
          </Col>
        )}

        <Col xs={3}>
          <SectionLabel>Checkin Selfie</SectionLabel>
          {mission.checkInSelfie ? (
            <ModalLightbox
              linkText="View check in photo"
              image={mission.checkInSelfie}
            />
          ) : (
            '-'
          )}
        </Col>
      </SectionRow>

      <SectionRow>
        <Col xs={3}>
          <SectionLabel>Steps Walked</SectionLabel>
          {mission.checkoutStepsWalked ||
            getStepsFromActivity(mission.activities) ||
            '-'}
        </Col>

        <Col xs={3}>
          <SectionLabel>Comment</SectionLabel>
          {mission.comments || '-'}
        </Col>
        {mission.type === MISSION_ENUM_TYPES.LETTERBOX && (
          <div>
            <Col xs={3}>
              <SectionLabel>Addresses</SectionLabel>
              {formatFieldValue(mission.householdsAmount)}
            </Col>
            <Col xs={3}>
              <SectionLabel>Density</SectionLabel>
              {formatFieldValue(mission.density)}
            </Col>
          </div>
        )}
        <Col xs={3}>
          <SectionLabel>Scans</SectionLabel>
          {mission.amountScans}
        </Col>
        {metrics.map(({ name, value }) => (
          <Col xs={3}>
            <SectionLabel>{name}</SectionLabel>
            {value}
          </Col>
        ))}
      </SectionRow>

      <SectionRow>
        <Col xs={12}>
          {mission.id && (
            <MissionMap
              mission={mission}
              shouldShowCurrentPosition={shouldShowCurrentPosition}
            />
          )}
        </Col>
      </SectionRow>
    </Section>
  )
}

MissionDetails.propTypes = {
  mission: PropTypes.object.isRequired,
}

export { MissionDetails }



// WEBPACK FOOTER //
// ./src/Containers/Mission/Details/MissionDetails/index.js